import { useModel } from "@bcm-dev/bcms-vite";
import ChangeProfilePage from "components/pages/ChangeProfilePage";
import ZellePage from "components/pages/ZellePage";
import CaptureNotShownView from "components/shared/views/CaptureNotShownView";

/**
 * @function CaptureChangeProfile
 * @param {Void} - No arguments are passed.
 * @returns {React.Component}
 * @description This component is used in the "Zelle" capture group.
 */
export default function CaptureZelleZelle(props) {
    const { branding } = useModel();
    const { options } = branding;
    const hasMultiProfileOptionOn = options.multiprofile_abi22 === "true";
    const howIsZellePresented = options.present_zelle_abi22 ? options.present_zelle_abi22.toLowerCase() : undefined;

    if(howIsZellePresented === "checkfree") {
        const message = `This capture is not shown when ABI22 branding option "How is Zelle Presented?" is set to "Checkfree".`;
        return <CaptureNotShownView message={ message }/>;
    }

    return hasMultiProfileOptionOn ? <ChangeProfilePage/> : <ZellePage />
}